(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-set-search-params.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-set-search-params.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useCallback
} = React;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const useSetSearchParams = () => {
  const searchParams = useSearchParams();
  const history = useHistory();
  const location = useLocation();
  const updateQueryString = useCallback(paramsObj => {
    const finalParamsObj = _objectSpread({}, searchParams);
    Object.keys(paramsObj).forEach(key => {
      if (paramsObj[key]) {
        finalParamsObj[key] = paramsObj[key];
      } else {
        delete finalParamsObj[key];
      }
    });
    Object.keys(finalParamsObj).forEach(key => {
      if (!finalParamsObj[key] || Array.isArray(finalParamsObj[key]) && !finalParamsObj[key].length) {
        delete finalParamsObj[key];
      }
    });

    const qs = new URLSearchParams(finalParamsObj);
    history.replace({
      pathname: location.pathname,
      search: "".concat(qs)
    });
  }, [searchParams, history, location.pathname]);
  const setFilter = useCallback(_ref => {
    let {
      type,
      name,
      checked
    } = _ref;
    const updateObj = _objectSpread({}, searchParams);
    const includesFilter = updateObj[type].includes(name);
    if (checked && !includesFilter) {
      updateObj[type] = [...updateObj[type], name];
    } else if (!checked && includesFilter) {
      updateObj[type] = updateObj[type].filter(category => category !== name);
    }
    updateQueryString(updateObj);
  }, [searchParams, updateQueryString]);
  const setQuery = useCallback(query => {
    updateQueryString({
      q: encodeURIComponent(query)
    });
  }, [updateQueryString]);
  const setListIds = useCallback(function () {
    let listIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(listIds)) {
      return;
    }
    const updateObj = _objectSpread({}, searchParams);
    updateObj.listIds = listIds.map(id => encodeURIComponent(id));
    updateQueryString(updateObj);
  }, [searchParams, updateQueryString]);
  const setSorting = useCallback(sortingMode => {
    updateQueryString({
      sorting: encodeURIComponent(sortingMode)
    });
  }, [updateQueryString]);
  const setTab = useCallback(tab => {
    updateQueryString({
      tab: encodeURIComponent(tab)
    });
  }, [updateQueryString]);
  const clearFilterParams = useCallback(shouldClearProviders => {
    if (shouldClearProviders) {
      updateQueryString({
        categories: [],
        providers: [],
        tags: []
      });
    } else {
      updateQueryString({
        categories: [],
        tags: []
      });
    }
  }, [updateQueryString]);
  const clearParams = useCallback(() => {
    updateQueryString({
      q: '',
      sorting: '',
      categories: [],
      providers: [],
      tags: [],
      returnUrl: ''
    });
  }, [updateQueryString]);
  return {
    setQuery,
    setFilter,
    setSorting,
    setListIds,
    setTab,
    clearFilterParams,
    clearParams
  };
};
setGlobal('svs.components.casino_react.hooks.useSetSearchParams', useSetSearchParams);

 })(window);